class InMemoryStorage implements Storage {
  private static instance: InMemoryStorage;
  private storage: Map<string, string> = new Map();
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  // Public method to get the singleton instance
  public static getInstance(): InMemoryStorage {
    if (!InMemoryStorage.instance) {
      InMemoryStorage.instance = new InMemoryStorage();
    }
    return InMemoryStorage.instance;
  }

  get length(): number {
    return this.storage.size;
  }

  clear(): void {
    this.storage.clear();
  }

  getItem(key: string): string | null {
    return this.storage.get(key) ?? null;
  }

  key(index: number): string | null {
    const keys = Array.from(this.storage.keys());
    return keys.length > index ? keys[index] : null;
  }

  removeItem(key: string): void {
    this.storage.delete(key);
  }

  setItem(key: string, value: string): void {
    this.storage.set(key, value);
  }
}

function storageAvailable(type: string) {
  let storage;
  try {
    storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

export function getStorageInstance() {
  let storage;
  if (storageAvailable('sessionStorage')) {
    storage = window.sessionStorage;
  } else {
    storage = InMemoryStorage.getInstance();
  }
  return storage;
}
